import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const ShellContext = createContext(null);
export function ShellProvider({ children, initialItems = [] }) {
    const [navItems, setNavItems] = useState(initialItems);
    const registerNavItem = useCallback((item) => {
        setNavItems((prev) => {
            if (prev.some((n) => n.id === item.id))
                return prev;
            return [...prev, item].sort((a, b) => (a.order ?? 99) - (b.order ?? 99));
        });
        return () => setNavItems((prev) => prev.filter((n) => n.id !== item.id));
    }, []);
    const value = useMemo(() => ({ navItems, registerNavItem }), [navItems, registerNavItem]);
    return _jsx(ShellContext.Provider, { value: value, children: children });
}
export function useShell() {
    const ctx = useContext(ShellContext);
    if (!ctx)
        throw new Error('useShell must be used inside ShellProvider');
    return ctx;
}
